import Api from "lib/api";
export const API_PATH = "/api/v1/notifications";

export const getNotifications = async () => {
  return Api.get(`${API_PATH}/notifications`);
};
export const getNotificationsCount = async () => {
  return Api.get(`${API_PATH}/get-notification-count`);
};
export const setNotificationsAsRead = async (notification) => {
  return Api.post(`${API_PATH}/set-as-read`, notification);
};
